<div class="space-y-4">
  <fieldset>
    <legend class="mb-2 text-sm font-medium text-fg">
      Kies één of meer uren
    </legend>
    <!-- Selectable chips rather than a row of small boxes: there are only three slots,
         the whole chip is the target instead of a 20px checkbox, and the chosen hours
         are readable at a glance. The input stays in the chip so the control is still a
         real checkbox for the keyboard and for assistive tech.

         An hour that already has a class renders CHECKED and disabled, not struck
         through: a class does exist at that hour, so the box reflects reality and the
         disabled state says only that this screen will not change it. -->
    <div class="flex flex-wrap gap-3">
      @for (timeslot of timeSlots; track timeslot) {
        <label
          class="flex min-h-11 items-center gap-2 rounded-md px-4 text-base font-semibold transition-colors"
          [class]="
            isTaken(timeslot)
              ? 'cursor-not-allowed bg-surface-raised text-fg-subtle'
              : selectedTimeSlots.includes(timeslot)
                ? 'cursor-pointer bg-brand/15 text-brand inset-ring inset-ring-brand/40'
                : 'cursor-pointer bg-surface-raised text-fg-muted hover:text-fg'
          "
        >
          <input
            appCheckbox
            type="checkbox"
            [id]="'timeslot-' + timeslot"
            [value]="timeslot"
            [checked]="
              selectedTimeSlots.includes(timeslot) || isTaken(timeslot)
            "
            [disabled]="isTaken(timeslot)"
            (change)="toggleTimeSlot(timeslot)"
          />
          {{ timeslot }}
          <!-- Written out rather than a title tooltip: a disabled input takes no focus
               and a phone has no hover, so the tooltip was a reason nobody could reach. -->
          @if (isTaken(timeslot)) {
            <!-- Its own colour, not the chip's: a disabled control may sit under 4.5:1,
                 but the sentence explaining why it is disabled has to be readable. -->
            <span class="text-xs font-normal text-fg-muted">al ingepland</span>
          }
        </label>
      }
    </div>
  </fieldset>

  <button
    appButton
    type="button"
    [disabled]="selectedTimeSlots.length === 0"
    (click)="emitTimeSlots()"
  >
    <app-icon name="calendar-plus" size="size-4" />
    {{
      selectedTimeSlots.length > 1
        ? 'Lessen aanmaken'
        : selectedTimeSlots.length === 1
          ? 'Les van ' + selectedTimeSlots[0] + ' aanmaken'
          : 'Les aanmaken'
    }}
  </button>
</div>
